function Contact() {
  return (
    <section>
      <h1>Contact</h1>
      <p>Questions? Reach out at dummy@example.com and we will respond soon.</p>
    </section>
  );
}

export default Contact;

